import { debounce } from "lodash";
import { useLayoutEffect, useState } from "react";

import { breakpoints } from "@/styles/screens";

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < breakpoints.tablet,
  );

  useLayoutEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const updateSize = (): void => {
      setIsMobile(window.innerWidth < breakpoints.tablet);
    };
    const debouncedUpdateSize = debounce(updateSize, 250);
    window.addEventListener("resize", debouncedUpdateSize);

    return (): void => {
      window.removeEventListener("resize", debouncedUpdateSize);
      debouncedUpdateSize.cancel();
    };
  }, []);

  return isMobile;
};
